import a from "./index417.js";
import { resolveComponent as i, createElementBlock as n, openBlock as s, normalizeClass as l, createElementVNode as e, createCommentVNode as d, normalizeStyle as m, renderSlot as c, createVNode as u, withCtx as f, toDisplayString as _ } from "vue";
/* empty css         */
import C from "./index231.js";
const g = ["data-component"], y = { ref: "croppedCopyContent" }, B = { class: "ms-croppedCopy__toggleButtonLabel" };
function v(o, t, b, h, $, k) {
  const p = i("ms-interactive-icons");
  return s(), n("div", {
    class: l(["ms-croppedCopy", { "-open": o.state.isOpen, "-disabled": o.isDisabled, "-noButton": !o.state.showButton }]),
    "data-component": o.$options.name
  }, [
    e("div", {
      class: "ms-croppedCopy__content",
      style: m({ height: o.state.contentHeight })
    }, [
      e("div", y, [
        c(o.$slots, "default", {}, void 0, !0)
      ], 512)
    ], 4),
    o.state.showButton ? (s(), n("button", {
      key: 0,
      class: "ms-croppedCopy__toggleButton",
      type: "button",
      onClick: t[0] || (t[0] = (...r) => o.onToggle && o.onToggle(...r))
    }, [
      u(p, null, {
        default: f(() => t[1] || (t[1] = [
          e("i", { class: "ms-croppedCopy__toggleButtonIcon" }, null, -1)
        ])),
        _: 1
      }),
      e("span", B, _(o.buttonText()), 1)
    ])) : d("", !0)
  ], 10, g);
}
const V = /* @__PURE__ */ C(a, [["render", v], ["__scopeId", "data-v-fd1f265f"]]);
export {
  V as default
};
